import { createAsyncThunk } from '@reduxjs/toolkit';
import { atsJobDetailsActions } from './atsJobDetailsReducer';

// todo: need to update these, for now added some sample
const actionsConfig = {
  getCandidateList: {
    method: 'post',
    endpoint: '/ats_jobs/:jobId/search/ats_applications/',
    thunkName: 'candidateList',
    reducerName: 'candidateList',
    responseKey: 'data',
  },
  getStagesCount: {
    method: 'post',
    endpoint: '/ats_jobs/:jobId/search/ats_applications/count_by_stage',
    thunkName: 'getStagesCount',
    reducerName: 'getStagesCount',
    responseKey: 'data',
  },
  rejectCandidate: {
    method: 'post',
    endpoint: '/ats_applications/:applicationId/reject',
    thunkName: 'rejectCandidate',
  },
  bulkRejectCandidate: {
    method: 'post',
    endpoint: '/ats_applications/bulk_reject',
    thunkName: 'bulkRejectCandidate',
  },
  moveToStage: {
    method: 'post',
    endpoint: '/ats_applications/:applicationId/move',
    thunkName: 'moveToStage',
  },
  bulkMoveToStage: {
    method: 'post',
    endpoint: '/ats_applications/bulk_move',
    thunkName: 'bulkMoveToStage',
  },
  sendEmail: {
    method: 'post',
    endpoint: '/ats_applications/bulk_email',
    thunkName: 'sendEmail',
  },
  bulkSendEmail: {
    method: 'post',
    endpoint: '/ats_applications/bulk_email',
    thunkName: 'bulkSendEmail',
  },
  addToJob: {
    method: 'post',
    endpoint: '/ats_applications',
    thunkName: 'addToJob',
  },
  bulkAddToJob: {
    method: 'post',
    endpoint: '/ats_applications/bulk_create',
    thunkName: 'bulkAddToJob',
  },
  createContact: {
    method: 'post',
    endpoint: '/contacts',
    thunkName: 'createContact',
    reducerName: 'createContact',
  },
  importContact: {
    method: 'post',
    endpoint: '/ats_applications/bulk_create_from_contacts',
    thunkName: 'importContact',
    reducerName: 'importContact',
  },
  getKanbanList: {
    method: 'post',
    endpoint: '/ats_jobs/:jobId/search/ats_applications/filter_by_stage',
    thunkName: 'kanbanList',
    reducerName: 'kanbanList',
    responseKey: 'data',
  },
  getRejectedCount: {
    method: 'post',
    endpoint: '/ats_jobs/:jobId/search/ats_applications/count',
    thunkName: 'rejectedCount',
    reducerName: 'rejectedCount',
    responseKey: 'data',
  },
  getCurrentApplication: {
    method: 'get',
    endpoint: `/ats_applications/:applicationId`,
    thunkName: 'currentApplication',
    reducerName: 'currentApplication',
    responseKey: 'data',
  },
  getCurrentApplicationActivities: {
    method: 'get',
    endpoint: `/ats_applications/:applicationId/activities`,
    thunkName: 'currentApplicationActivities',
    reducerName: 'currentApplicationActivities',
  },
  getCurrentJobActivities: {
    method: 'get',
    endpoint: `/ats_jobs/:jobId/activities`,
    thunkName: 'currentJobActivities',
    reducerName: 'currentJobActivities',
  },
};

function replacePathParameters(endpoint, pathParams) {
  if (!pathParams || typeof pathParams !== 'object') {
    // Handle the case where pathParams is undefined, null, or not an object
    return endpoint;
  }

  const regex = new RegExp(`:${Object.keys(pathParams).join('|')}`, 'g'); // Create a global regex
  return endpoint.replace(regex, (match) => pathParams[match.slice(1)]); // Use a callback for replacement
}

const apiAction = async (currentAction, config, args) => {
  // eslint-disable-next-line no-unused-vars
  const [dispatch, getState, extraArgument] = args;
  const { atsHttp } = extraArgument;
  const { endpoint, method, reducerName: key, responseKey } = currentAction;
  const { requestConfig = {}, isBackground = false, pathParams = {} } = config;
  const { setLoadingState, setApiData } = atsJobDetailsActions;

  // If isBackground skip setting loading state to avoid showing loaders
  if (!isBackground) {
    dispatch(setLoadingState({ key, isLoading: true }));
  }
  const updatedEndpoint = replacePathParameters(endpoint, pathParams);
  try {
    const result = await atsHttp[method](updatedEndpoint, { ...requestConfig });
    const response = responseKey ? result[responseKey] : result;
    dispatch(
      setApiData({
        key,
        data: response,
        status: result?.status,
        isLoading: false,
      })
    );
    return response;
  } catch (error) {
    dispatch(setApiData({ key, error: error.message, isLoading: false }));
    console.error(`Error fetching data from ${endpoint}:`, error);
    throw new Error(`Failed to fetch data from ${endpoint}`);
  }
};

export const atsJobDetailsApiActions = (actionId, config = {}) => {
  // note: to use params, pass it directly inside requestConfig like below
  // requestConfig: { params: queryParams }
  const currentAction = actionsConfig[actionId];
  const { isApi } = config;
  if (!currentAction)
    return console.error('no actions config found for ats job create');

  let { endpoint, thunkName } = currentAction;

  if (isApi) {
    return (...args) => {
      return apiAction({ ...currentAction, endpoint }, config, args);
    };
  }

  return (...args) => {
    return createAsyncThunk(
      thunkName,
      apiAction({ ...currentAction, endpoint }, config, args)
    );
  };
};
